import type { ID } from "@constants";
import { generatePath } from "@routes/generatePath";

const medicalCenterPath = "/medical-center-management";

export const path = {
  medicalCenterManagement: {
    route: medicalCenterPath,
    link: () => path.medicalCenterManagement.route,
  },
  medicalCenterManagementCreate: {
    route: `${medicalCenterPath}/create`,
    link: () => path.medicalCenterManagementCreate.route,
  },
  medicalCenterManagementEdit: {
    route: `${medicalCenterPath}/edit/:id`,
    link: (id: ID) => generatePath(`${medicalCenterPath}/edit/:id`, { id }),
  },
  medicalCenterManagementView: {
    route: `${medicalCenterPath}/view/:id`,
    link: (id: ID) => generatePath(`${medicalCenterPath}/view/:id`, { id }),
  },
  prescriptionList: {
    route: "/prescription-list",
    link: () => path.prescriptionList.route,
  },
  experimentList: {
    route: "/experiments-list",
    link: () => path.experimentList.route,
  },
  imagesList: {
    route: "/images-list",
    link: () => path.imagesList.route,
  },
  prescriptionView: {
    route: "/prescription-list/:id/:appointmentId",
    link: (id: ID, appointmentId: ID) =>
      generatePath("/prescription-list/:id/:appointmentId", {
        id,
        appointmentId,
      }),
  },
  experimentsView: {
    route: "/experiments-list/:id/:appointmentId",
    link: (id: ID, appointmentId: ID) =>
      generatePath("/experiments-list/:id/:appointmentId", {
        id,
        appointmentId,
      }),
  },
  imagesView: {
    route: "/images-list/:id/:appointmentId",
    link: (id: ID, appointmentId: ID) =>
      generatePath("/images-list/:id/:appointmentId", {
        id,
        appointmentId,
      }),
  },
  mspDoctors: {
    route: "/msp-doctors",
    link: () => path.mspDoctors.route,
  },
  assignMspList: {
    route: "/assign-msp",
    link: () => path.assignMspList.route,
  },

  assignMspCreate: {
    route: "/assign-msp/create",
    link: () => path.assignMspCreate.route,
  },
  assignMspAdd: {
    route: "/assign-msp/add/:id",
    link: (id: ID) => generatePath("/assign-msp/add/:id", { id }),
  },
  viewAssignedMsp: {
    route: "/assign-msp/view/:id",
    link: (id: ID) => generatePath("/assign-msp/view/:id", { id }),
  },
  mspReports: {
    route: "/msp/reports",
    link: () => path.mspReports.route,
  },
};
